module.exports = __webpack_public_path__ + "static/flags/TV-586b8fc5ffe23ff2a52621140f316926.gif";